import React from 'react'
import './index.scss'

export default function Button(props) {
  let { text, fn } = props
  return (<div className="Button" onClick={fn}>
    {text}
  </div>)
}